import {Pipe, Injectable, PipeTransform} from '@angular/core'
import lowerCase from 'lodash-es/lowerCase'
import upperFirst from 'lodash-es/upperFirst'

export interface SentenceCasePipeOptions {
  upperFirst: boolean
}

export const defaultPipeOptions: SentenceCasePipeOptions = {
  upperFirst: true
}

@Pipe({
  name: 'sentencecase',
  pure: true
})
@Injectable()
export class SentenceCasePipe implements PipeTransform {
  transform(str: string, options: SentenceCasePipeOptions = defaultPipeOptions): any {
    let sentence = lowerCase(str)
    if (options.upperFirst) {
      sentence = upperFirst(sentence)
    }
    return sentence
  }
}
